import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {routerTransition} from '../router.animations';
import {FormControl, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material';
import {ConfirmationDialogComponent} from '../layout/mycomponents/shared/confirmation-dialog/confirmation-dialog.component';
import {ForgotPasswordComponent} from '../layout/mycomponents/shared/forgot-password/forgot-password.component';
import {LoginProvider} from './loginProvider';
import {AuthService, User} from '../utility/auth-service';
import {LoginRequest} from '../request/LoginRequest';
import {SiUtil} from '../utility/SiUtil';
import {Validator} from '../utility/Validator';
import {Compiler} from '@angular/core';
import {SignUpDialogComponent} from '../signup-dialog/signup-dialog.component';
import {LazyLoadRequest} from '../request/LazyLoadRequest';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [routerTransition()]
})
export class LoginComponent implements OnInit {
    operatingList: any[] = [];
    loading: boolean = false;
    userType: string;
    login: {username?: string, password?: string} = {};
    hide = true;
    username = new FormControl('', [Validators.email, Validators.required]);
    password = new FormControl('', [Validators.required, Validators.maxLength(15), Validators.minLength(5)]);
    levelList = ['Organization Level', 'Operating Unit'];
    API_LAZY_LIST = "/api/cust/getCustList";
    public lazyCriteria: LazyLoadRequest;
    constructor(private util: SiUtil,
        private router: Router,
        private dialog: MatDialog,
        private provider: LoginProvider, private auth: AuthService, private validation: Validator, private _compiler: Compiler) {
    }




    ngOnInit() {
        this.getCustomerList();
        this._compiler.clearCache();
    }

    validEmail() {
        return this.username.hasError('required') ? 'You must enter a value' :
            this.username.hasError('email') ? 'Not a valid email' :
                '';
    }

    validPassword() {
        return this.password.hasError('required') ? 'You must enter a value' :
            this.password.hasError('maxLength') ? 'Max character is 15' :
                this.password.hasError('minLength') ? 'Min character is 5' :
                    '';
    }

    onLoggedin() {
        if (this.validation.validateField(this.login.username) && this.validation.validateField(this.login.password)) {
            var req = new LoginRequest();
            req.username = this.login.username;
            req.password = window.btoa(this.login.password);
            //            //            req.password = (this.login.password);
            //            if (this.login.password === "12345678") {
            //                req.password = window.btoa(this.login.password);
            //            } else {
            //                req.password = (this.login.password);
            //            }
            //            //                        req.password = this.login.password;
            ////            this.login.password = this.login.password;
            //            if (this.login.password === "12345678") {
            //                this.login.password = window.btoa(this.login.password);
            //                console.log(this.login.password);
            //            } else {
            //                this.login.password = (this.login.password);
            //                console.log(this.login.password);
            //            }
            console.log("Login Requestttttttttttttttttttttttttttttt");
            console.log(req)
            this.provider.doLogin(req).subscribe((data: any) => {
                if (data.message == "username is incorrect") {
                    this.util.toastError(" Entered Wrong UserName")
                } else {
                    if (data.message == "Password is wrong") {
                        console.log("wrong password");
                        this.util.toastError(" Entered Wrong Password")
                    } else {
            this.loading = this.util.showLoading();
                        console.log(data);
                        localStorage.setItem('isLoggedin', 'true');
                        var userSession: User = {
                            uid: data.username,
                            email: data.username,
                            User_Role: data.roles[0],
                            id_mongo: data.id,
                            token: data.accessToken,
                            token_Type: data.tokenType,
                            ORG_ID: data.org_id,
                            OPR_ID: data.opr_id,
                            CR_BY: data.cr_by,
                            MD_DT: data.md_dt,
                            CR_DT: data.cr_dt,
                            MD_BY: data.md_by,
                            app_role_id: data.app_role_id,
                            userType: data.userType,
                            isExpire: data.isExpire,
                            remainingDays: data.remainingDays,

                        }
                        this.auth.setUserDataToSessionNew(userSession);

                        this.router.navigate(['/dashboard']);
                    }
                }
            }, error => {
                this.util.toastError(error.error.error)
                console.log(error);
                this.loading = this.util.hideLoading();
            })
        }
        console.log(localStorage);
    }
    getCustomerList() {
        //        console.log(this.auth.getSession().uid);
        this.lazyCriteria = new LazyLoadRequest();
        this.lazyCriteria.pageSize = 100;
        console.log(this.lazyCriteria);
        this.lazyCriteria.paramObj = {
            //            crBy: this.auth.getSession().uid
        }
        console.log(this.lazyCriteria);
        this.provider.doHttpPost(this.API_LAZY_LIST, this.lazyCriteria, false).subscribe((data: any) => {
            console.log(data);
        })
    }
    openSigninDialog() {
        const dialogRef = this.dialog.open(SignUpDialogComponent, {
            height: '90%',
            width: '60%'
        });

        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);

        });

    }

    onRegisterIn() {
        this.router.navigate(['/registration']);
    }

    onOpen() {
        this.router.navigate(['/dashboard']);
    }
    showError(errorMessage: string, firstButtonText: string) {
        let dialogBoxSettings = {
            width: '400px',
            disableClose: true,
            hasBackdrop: true,
            margin: '0, auto',
            data: {alertMessage: errorMessage, firstButtonText: firstButtonText}
        }
        this.dialog.open(ConfirmationDialogComponent, dialogBoxSettings);
    }

    forgotPassword() {
        this.showForgotPasswordDialog()
    }

    showForgotPasswordDialog() {
        let dialogBoxSettings = {
            width: '400px',
            height: '320px',
            disableClose: true,
            hasBackdrop: true,
            margin: '0, auto',
        }
        const dialogRef = this.dialog.open(ForgotPasswordComponent, dialogBoxSettings);

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('Yes clicked: ${result}');
            }
        });
    }

    //    getUserType($event) {
    //        this.userType = $event.value;
    //        if (this.userType == "Operating Unit") {
    //            this.provider.getListOfOPR().subscribe((list: any[]) => {
    //                this.operatingList = list
    //            })
    //        }
    //        else {
    //            this.operatingList.length = 0;
    //        }
    //    }

    public onNewClickedAction(event?) {
        throw new Error("Method not implemented.");
    }

    public onNewSaveAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onModifyClickedAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onUpdateSaveAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onRemoveClickedAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onDeleteSaveAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onViewClickedAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onUploadClickedAction(event?) {
        throw new Error("Method not implemented.");
    }
    public onClearClickedAction() {
        throw new Error("Method not implemented.");
    }


}
